// src/components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const isAuthenticated = checkSession(); // Your session validation function
  
  if (!isAuthenticated) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/sesion" replace state={{ from: window.location.pathname }} />;
  }
  
  return children;
}

// Helper function to check session
function checkSession() {
  // Check localStorage, cookies, or API token
  //const id_usuario = sessionStorage.getItem('id_usuario');
  const t_u = sessionStorage.getItem('token_nk107803');
  //const tip_u = sessionStorage.getItem('tipo_usuario');
  // Add more validation logic here
  return !!t_u;
}

export default ProtectedRoute;